import {
  DEFAULT_IMAGE_CROP,
  DEFAULT_IMAGE_FILTER_SETTINGS,
  DEFAULT_IMAGE_VIEW_SETTINGS,
  ImageEditorSource,
  ImageProject
} from '../models/image-project.model';
import { createImageEditorId, safeImageEditorFileName } from './image-editor-id.util';

export interface CreateImageProjectOptions {
  source: ImageEditorSource;
  imageUrl: string;
  title?: string | null;
  description?: string | null;
  width?: number | null;
  height?: number | null;
  fileName?: string | null;
  createdAt?: string | null;
}

export function createImageProject(options: CreateImageProjectOptions): ImageProject {
  const title = (options.title || '').trim() || 'Untitled image';
  const width = options.width || 1080;
  const height = options.height || 1080;

  return {
    id: createImageEditorId('image-project'),
    source: options.source,
    image: {
      url: options.imageUrl,
      width,
      height,
      fileName: options.fileName || null
    },
    metadata: {
      title,
      description: options.description || ''
    },
    canvas: {
      width,
      height,
      fabricJson: null
    },
    filters: {
      activeFilterId: 'original',
      cssFilter: 'none',
      settings: { ...DEFAULT_IMAGE_FILTER_SETTINGS }
    },
    crop: { ...DEFAULT_IMAGE_CROP },
    layers: [
      {
        id: createImageEditorId('base-image'),
        type: 'base-image',
        name: 'Image',
        visible: true,
        locked: true,
        opacity: 1,
        zIndex: 0,
        transform: { x: 0, y: 0, width, height, rotation: 0 },
        asset: { url: options.imageUrl }
      }
    ],
    selectedLayerId: null,
    template: null,
    export: {
      target: options.source.kind === 'review'
        ? 'review'
        : options.source.kind === 'quick-edit' ? 'download' : 'social',
      mimeType: 'image/png',
      fileName: safeImageEditorFileName(title, 'png'),
      quality: 0.95,
      scale: 1,
      maxWidth: null,
      maxHeight: null,
      picaResizeMode: 'mks2013'
    },
    view: { ...DEFAULT_IMAGE_VIEW_SETTINGS },
    optionState: {},
    createdAt: options.createdAt || null
  };
}
